import { render, staticRenderFns } from "./LocaleInput.vue?vue&type=template&id=b38324bc"
import script from "./LocaleInput.vue?vue&type=script&lang=js"
export * from "./LocaleInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports